import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "sorted-up fa fa-caret-up",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", {
    class: "sorted-down fa fa-caret-down",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "sortable",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.changeSort && _ctx.changeSort(...args)), ["prevent"]))
    }, [
        _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default"),
            _createTextVNode(),
            (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("span", {
            class: _normalizeClass(_ctx.cssClass)
        }, [
            _hoisted_2,
            _createTextVNode(),
            _hoisted_3
        ], 2 /* CLASS */)
    ]));
}
